// import store from '@/store/index'
export default {
    // elBtnSize (){
    //     return store.state.element.elBtwnSize
    // }
}